import { render } from "./CommentPage.vue?vue&type=template&id=0d34d534&scoped=true"
import script from "./CommentPage.vue?vue&type=script&lang=js"
export * from "./CommentPage.vue?vue&type=script&lang=js"

import "./CommentPage.vue?vue&type=style&index=0&id=0d34d534&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d34d534"]])

export default __exports__